import { createParentComponent } from "@/common/vueUtils";

type Variant = "danger";

export const ActionButton = createParentComponent<{ variant?: Variant; onClick?: () => void; disabled?: boolean; title?: string }>(({ variant, onClick, disabled, title, children }) => {
  const computedClasses = ["btn", "action-button", variant === "danger" ? "action-button--danger" : ""];
  const isDisabled = disabled ?? false;
  return (
    <button onClick={onClick} class={computedClasses} disabled={isDisabled} title={title}>
      {children}
    </button>
  );
});
